/*
    'Paga',
    'PalmPay',
    'Parallex_Bank',
    'Paycom' ,
    'Polaris_Bank',
    'Providus_Bank' ,
    'Rand_Merchant_Bank',
    'Rubies_MFB' ,
    'Stanbic_IBTC_Bank',
    'Standard_Chartered_Bank' ,
    'Sterling_Bank' ,
    'Suntrust_Bank' ,
     'Titan_Bank' ,
    'Union_Bank_of_Nigeria',
    'United_Bank_For_Africa ',
    'Unity_Bank' ,
    'VFD_Microfinance_Bank_Limited' ,
    'Wema_Bank',
    'Zenith_Bank'*/


export const BankData = [ 
    {name:'Access_Bank',code:'044'},
    {name:'Access_Bank_Diamond', code:'063'},
    {name:'ALAT_by_WEMA',code:'035A'} ,
    {name:'Carbon', code:'565'},
    {name:'Ecobank_Nigeria', code: '050'},
    {name:'Eyowo', code: '50126'},
    {name:'First_Bank_of_Nigeria', code: '011'},
    {name:'First_City_Monument_Bank', code: '214'},
    {name:'Globus_Bank', code: ''},
    {name:'Guaranty_Trust_Bank', code: '058'},
    {name:'Heritage_Bank', code: '030'},
    {name:'Kuda_Bank', code: '50211'},
    {name:'Keystone_Bank', code: '082'},
  
    
]